/**
 * Utility functions for formatting server metrics like bytes, CPU time, etc.
 */

/**
 * Format bytes into human-readable format (B, KB, MB, GB, TB)
 * @param bytes Number of bytes to format
 * @param decimals Number of decimal places to show (default: 2)
 */
export const formatBytes = (
  bytes: number,
  {
    decimals = 2,
    binary = false, // When true, uses 1024 (binary), otherwise uses 1000 (decimal)
  } = {}
): string => {
  if (bytes === 0) return "0 B";
  if (isNaN(bytes) || bytes === undefined) return "";

  const k = binary ? 1024 : 1000;
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB"];

  const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(k));

  // Don't format bytes as KB, MB, etc. - leave as B
  if (Math.abs(bytes) < k) return `${bytes} ${sizes[0]}`;

  return `${parseFloat((bytes / k ** i).toFixed(decimals))} ${sizes[i]}`;
};
